import { axi } from "../context/authContext";

const cleanParams = (params) =>
  Object.fromEntries(
    Object.entries(params).filter(
      ([, value]) => value !== "" && value !== null && value !== undefined,
    ),
  );

export const queryPowerSplitterMeters = async (params) => {
  const response = await axi.get("/api/v1/split-meters/get-meters", {
    params: cleanParams(params),
  });

  return response.data;
};

export const createPowerSplitterMeter = async (payload) => {
  const response = await axi.post("/api/v1/split-meters/enroll", payload);

  return response.data;
};

export const verifyPowerSplitterMeterInManifest = async (meterSn) => {
  const response = await axi.get(`/api/v1/manifest/verify-meter/${meterSn}`);

  return response.data;
};

export const updatePowerSplitterMeterAddress = async (meterSn, address) => {
  const response = await axi.put(
    `/api/v1/split-meters/update-address/${meterSn}`,
    { address },
  );

  return response.data;
};

export const updatePowerSplitterMeterName = async (meterSn, name) => {
  const response = await axi.put(
    `/api/v1/split-meters/update-splitter-meter/${meterSn}`,
    { name },
  );

  return response.data;
};

export const assignPowerSplitterMeterOwner = async (meterSn, owner) => {
  const response = await axi.put(
    `/api/v1/split-meters/assign-meter-to-owner/${meterSn}`,
    { owner },
  );

  return response.data;
};

export const togglePowerSplitterMeterLockdown = async (
  meterSn,
  isLockedDown,
) => {
  const response = await axi.put(
    `/api/v1/split-meters/toggle-lock-down/${meterSn}`,
    { isLockedDown },
  );

  return response.data;
};
